export function initStep2Data(brand, phone, email, zipCode, address, nameCountry, nameState, nameIndustry, nameCity) {
  return {
    brand: brand,
    phone: phone,
    email: email,
    zipCode: zipCode,
    address: address,
    nameCountry: nameCountry,
    nameState: nameState,
    nameIndustry: nameIndustry,
    nameCity: nameCity,
    isBrandError: false,
    isPhoneError: false,
    isEmailError: false,
    isZipCodeError: false,
    isAddressError: false
  }
}

export function initStep3Data(accountId) {
  return {
    accountId: accountId,
    isAccountIdError: false
  }
}

export function initStep4Data(fullName, phone, email, address) {
  return {
    fullName: fullName,
    phone: phone,
    email: email,
    address: address,
    isFullNameError: false,
    isPhoneError: false,
    isEmailError: false
  }
}

